import { Badge, Text } from '@shopify/polaris';
import { formatToCurrency } from '../functions';
import { lineDelta, matchLines } from './poLineMatching';

/*
  Purchase order lines next to the invoice lines (Peppol), paired by article code / description / quantity.
  Informational only: differences are shown, never enforced.
*/
const cell = { padding: '4px 6px', borderBottom: '1px solid #f0f0f0', verticalAlign: 'top', fontSize: 12 };

function DeltaBadge({ value, prefix = '', suffix = '' }) {
  if (!Number.isFinite(value) || Math.abs(value) < 0.005) return <Badge tone="success">=</Badge>;
  return <Badge tone="info">{`${value > 0 ? '+' : ''}${prefix}${Math.round(value * 100) / 100}${suffix}`}</Badge>;
}

export default function PoLinesDiff({ poLines = [], invoiceLines = [] }) {
  const { pairs, unmatchedPo, unmatchedInvoice } = matchLines(poLines, invoiceLines);
  const rows = [...pairs.map(({ po, inv, score }) => ({ po, inv, score })), ...unmatchedPo.map((po) => ({ po, inv: null, score: 0 })), ...unmatchedInvoice.map((inv) => ({ po: null, inv, score: 0 }))];
  if (!rows.length) {
    return <Text tone="subdued">No lines to compare.</Text>;
  }
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {['Purchase order line', 'Ordered', 'Received', 'Unit', 'Invoice line', 'Qty', 'Unit', 'Δ qty', 'Δ price', 'Δ total'].map((h) => (
              <th key={h} style={{ ...cell, textAlign: 'left', color: '#6d7175', fontWeight: 500 }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => {
            const delta = row.po && row.inv ? lineDelta(row.po, row.inv) : null;
            const muted = !(row.po && row.inv);
            return (
              <tr key={index} style={{ opacity: muted ? 0.6 : 1 }}>
                <td style={cell}>{row.po ? `${row.po.Productref ? `${row.po.Productref} · ` : ''}${row.po.tekstlijn || row.po.ProductNameNL || ''}` : <em>not on purchase order</em>}</td>
                <td style={cell}>{row.po ? row.po.aantal : ''}</td>
                <td style={cell}>{row.po ? row.po.ReceivedQty : ''}</td>
                <td style={cell}>{row.po ? formatToCurrency(row.po.AP) : ''}</td>
                <td style={cell}>{row.inv ? `${row.inv.ArtikelCode ? `${row.inv.ArtikelCode} · ` : ''}${row.inv.tekstlijn || ''}` : <em>not invoiced</em>}</td>
                <td style={cell}>{row.inv ? row.inv.aantal : ''}</td>
                <td style={cell}>{row.inv ? formatToCurrency(row.inv.VP) : ''}</td>
                <td style={cell}>{delta ? <DeltaBadge value={delta.qtyDelta} /> : ''}</td>
                <td style={cell}>{delta ? <DeltaBadge value={delta.priceDelta} prefix="€" /> : ''}</td>
                <td style={cell}>{delta ? <DeltaBadge value={delta.totalDelta} prefix="€" /> : ''}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
